export var SELECT_DISPLAY_NAME = 'Select';
export var OPTIONGROUP_DISPLAY_NAME = 'OptionGroup';
export var OPTION_DISPLAY_NAME = 'Option';